import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Seo from "../components/common/seo";
import Achievement from "../components/achievements/achievement";

import INFO from "../data/user";
import myachievements from "../data/achievements";

import "./styles/achievements.css";

const Achievements = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<Seo page="achievements" />

			<div className="page-content">
				<NavBar active="achievements" />
				<div className="content-wrapper">
					<div className="achievements-logo-container">
						<div className="achievements-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="achievements-main-container">
						<div className="title achievements-title">
							{INFO.achievements.title}
						</div>

						<div className="subtitle achievements-subtitle">
							{INFO.achievements.description}
						</div>

						<div className="achievements-container">
							<div className="achievements-wrapper">
								{myachievements.map((achievement, index) => (
									<div
										className="achievements-achievement"
										key={(index + 1).toString()}
									>
										<Achievement
											key={(index + 1).toString()}
											date={achievement().date}
											title={achievement().title}
											description={achievement().description}
											link={achievement().link}
											linkText={achievement().linkText}
										/>
									</div>
								))}
							</div>
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Achievements;
